const megamenuT2 = () => {
    const megamenuTypology2Widget = document.querySelector(".megamenu-typology2-widget");
    if (megamenuTypology2Widget) {
        const megaMenu = megamenuTypology2Widget.querySelector("[data-mega-menu]");
        const togglerList = megaMenu.querySelectorAll("[data-left-item]");
        if (togglerList && togglerList.length > 0) {
            togglerList.forEach((toggler) => {
                const value = toggler.getAttribute("data-toggler");
                toggler.addEventListener("click", () => {
                    const columnRightList = megaMenu.querySelectorAll("[div-column-right-wrapper]");
                    columnRightList.forEach((columnRight) => {
                        columnRight.classList.remove("active");
                    });
                });
                initToggler(`${value}`);
            });
        }
    }
};
